import React, { useEffect } from "react";
import logo from "./AuthLogo.png";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";

type LandingPageProps = {
  setAuthType: (type: "login" | "register") => void;
};

const LandingPage: React.FC<LandingPageProps> = () => {
  const [, navigate] = useLocation();
  const { user, logoutMutation } = useAuth();

  useEffect(() => {
    // logoutMutation.mutate();
  }, []);

  return (
    <div className="min-h-screen bg-[#eaf1f3] flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center px-4">
        {/* Logo */}
        <div className="flex justify-center mb-[32%]">
          <img src={logo} alt="In My Name KYC Logo" className="h-24 w-auto" />
        </div>
        {/* REG Code Enter Button (hidden when logged in) */}
        {!user && (
          <button
            onClick={() => navigate("/account-activation")}
            className="w-full bg-[#4c7375] hover:bg-teal-700 rounded-md h-12 text-white font-medium shadow-md transition-colors duration-300"
          >
            Start New Journey
          </button>
        )}
        {/* Continue Journey Button */}
        <button
          onClick={() => navigate("/login")}
          className="w-full bg-[#4c7375] hover:bg-teal-700 rounded-md h-12 text-white font-medium shadow-md transition-colors duration-300 mt-[2rem]"
        >
          Continue Your Journey
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
